import * as d3 from "d3";
import {interpolateRgb} from "d3";
import type {PaletteOptions, Theme} from "@mui/material";
import {darken, lighten} from "@mui/material";

// https://material.io/design/color/the-color-system.html
// https://material.io/resources/color/
// https://color.adobe.com/

export const COLOR_MITHRA_DARK_BLUE = '#001A40';
export const COLOR_MITHRA_LIGHT_BLUE = '#478FFA';
export const COLOR_UNCATEGORIZED = '#de4b1e';

const COLOR_GREY_100 = '#D1D6DD'

export const COLORS = {
    primary: {
        main: COLOR_MITHRA_DARK_BLUE,
    },
    secondary: {
        main: COLOR_MITHRA_LIGHT_BLUE,
    },
    text: {
        primary: '#1A1B20',
        secondary: 'rgba(25,48,79,0.54)',
    },
    success: {
        main: '#08A57A',
        contrastText: '#1A1B20',
    },
    warning: {
        main: '#FAA915',
        contrastText: '#1A1B20',
    },
    error: {
        main: '#FF3435',
        contrastText: '#1A1B20',
    },
    info: {
        main: '#4088F8',
        contrastText: '#1A1B20',
    },
    grey: {
        50: lighten(COLOR_GREY_100, 1 / 2),
        100: COLOR_GREY_100,
        200: darken(COLOR_GREY_100, 1 / 9),
        300: darken(COLOR_GREY_100, 2 / 9),
        400: darken(COLOR_GREY_100, 3 / 9),
        500: darken(COLOR_GREY_100, 4 / 9),
        600: darken(COLOR_GREY_100, 5 / 9),
        700: darken(COLOR_GREY_100, 6 / 9),
        800: darken(COLOR_GREY_100, 7 / 9),
        900: darken(COLOR_GREY_100, 8 / 9),
    }
} satisfies PaletteOptions;

// https://github.com/d3/d3-scale-chromatic/blob/master/README.md
const categoryColors = [COLORS.primary.main, COLOR_MITHRA_LIGHT_BLUE]
export const SUPPLIER_CUMULATIVE_COLOR = darken(categoryColors[0], 0.5);

export const categoryColorGradient = interpolateRgb.gamma(2.2)(categoryColors[0], categoryColors[1]);
export const primaryColorGradient = categoryColorGradient;

const colorSteps = 15;
export const vizColor = d3.scaleOrdinal([...Array(colorSteps)].map((_, i) =>
    // primaryColorGradient(i / (colorSteps - 1) * 0.3)
    primaryColorGradient(i / (colorSteps - 1))
));

export function getColorByCat(category: string | null): string {
    if (category === '' || category === null) {
        return COLOR_UNCATEGORIZED;
    } else {
        return vizColor(category);
    }
}

export function getColorMonotone(theme: Theme | any, category: string | null): string {
    if (category === '' || category === null) {
        return COLOR_UNCATEGORIZED;
    }
    if (!theme.palette?.primary?.main) {
        console.warn('Migration breaking change from MUI v4')
        return COLORS.primary.main;
    }
    return theme.palette.primary.main;
}
